import React from 'react';

import Head from 'next/head';
import { pageProps } from '../../../../helpers/propTypes';
import { isBrowser } from '../../../../helpers/formatPrice';
import Header from '../../../header/Header';
import FloatingNavigation from '../../../navigation/FloatingNavigation';

export default function StaticPage({ navbar, page }) {
  // Когда открываем из мобильного меню, остается position = fixed и перестает работать скролл
  if (isBrowser()) {
    document.body.style.position = '';
  }

  return (
    <>
      <Head>
        <title>{page.seo_title}</title>
        <meta property="og:title" content={page.seo_title} />
        <meta property="og:description" content={page.seo_description} />
        <meta name="description" content={page.seo_description} />
      </Head>
      <FloatingNavigation>
        <Header menu={navbar} backUrl="/" />
      </FloatingNavigation>
      <div className="container p-5" style={{ marginBottom: 100 }}>
        <div className="row">
          <div className="col">
            <h1>{page.title}</h1>
            <div className="row" dangerouslySetInnerHTML={{ __html: page.text }} />
          </div>
        </div>
      </div>
    </>
  );
}

StaticPage.propTypes = {
  page: pageProps.isRequired,
};
